import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const getNotificationsForOperatorApi = async () => {
    try {
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const res = await axios.get(`${API_URL}/api/notification/getForOperator/${id}`);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const markNotificationAsReadApi = async (notificationID) => {
    try {
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const res = await axios.put(`${API_URL}/api/notification/markRead/${id}/${notificationID}`);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const markAllNotificationsAsReadApi = async () => {
    try {
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const res = await axios.put(`${API_URL}/api/notification/markAllRead/${id}`);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const clearOneNotificationApi = async (notificationID) => {
    try {
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const res = await axios.put(`${API_URL}/api/notification/clearOne/${id}/${notificationID}`);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const clearAllNotificationsApi = async () => {
    try {
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const res = await axios.put(`${API_URL}/api/notification/clearAll/${id}`);
        return res.data
    }
    catch (err) {
        throw err
    }
}
